import BenchlingConfig from 'BenchlingConfig';
import {StructuredTableKind} from 'notebook/structured-tables/StructuredTableConstants';
import getAllStructuredTablesInNote from 'notebook/structured-tables/util/getAllStructuredTablesInNote';
import tableHasUnsubmittedChanges from 'notebook/structured-tables/util/tableHasUnsubmittedChanges';
import {Note} from 'notebook/util/NoteUtilConstants';
import EntryStore from 'stores/EntryStore';

export const OUTPUT_SUBMISSION_BLOCKED_BY_TASK_TABLE_TOOLTIP =
  'Submit the task table before submitting outputs.';

/**
 * Returns true if outputs cannot be submitted because the entry's task table has unsubmitted changes,
 * using the same `tableHasUnsubmittedChanges` check that drives the task table's own Submit button.
 */
export default function isOutputSubmissionBlockedByTaskTable({
  entryOrTemplateId,
  note: renderedNote,
}: {
  entryOrTemplateId: string | null;
  note?: Note | null;
}): boolean {
  if (!BenchlingConfig.WORKFLOWS_ENABLE_OUTPUT_SUBMIT_REQUIRES_SUBMITTED_TASK_TABLE) {
    return false;
  }
  const note =
    entryOrTemplateId != null && EntryStore.inStore(entryOrTemplateId)
      ? EntryStore.getNote(entryOrTemplateId)
      : renderedNote;
  if (note == null) {
    return false;
  }
  const taskTable = getAllStructuredTablesInNote(note).find(
    (structuredTable) => structuredTable.kind === StructuredTableKind.PROCESS_TASK
  );
  if (taskTable == null) {
    return false;
  }
  const computedTable = note.noteRuntimeSnapshot?.evaluationSnapshot?.[taskTable.name];
  if (computedTable == null) {
    return false;
  }
  return tableHasUnsubmittedChanges(taskTable, computedTable);
}
